<div class="d-flex justify-content-center">
  <div class="spinner-border text-dark" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>